import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UserService} from "../service/user.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  // Elenco delle URL da escludere (può essere endpoint completi o porzioni)
  private whitelist: string[] = [
    '/users/login',
    '/users/register',
    '/users/login',
    'www.sanita.puglia.it',
    'www.andriaviva.it'
  ];

  constructor(private userService: UserService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Verifica se la richiesta è in whitelist
    const isWhitelisted = this.whitelist.some(url => req.url.includes(url));

    if (isWhitelisted) {
      return next.handle(req); // Non aggiunge il token
    }

    if (this.userService.token) {
      const cloned = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.userService.token.accessToken}`,
        }
      });
      return next.handle(cloned);
    }
    return next.handle(req);
  }
}
